import * as React from 'react';
// import { FormFieldInput } from '@cian/ui-kit/form';
import { FormFieldInput, IFormFieldInputProps } from '@cian/ui-kit';

/**
 * Input высотой 40px не зависимо от ширины экрана и типа устройства
 */
export interface IFormInputProps extends IFormFieldInputProps {
  'data-testid'?: string;
}

export const FormInput: React.FC<React.PropsWithChildren<IFormInputProps>> = props => (
  <FormFieldInput {...props} size="M" />
);

FormInput.displayName = 'FormInput';
